module.exports = __webpack_public_path__ + "assets/img/lb3.25633a1c.jpg";